<template>
  <div>
    <MessagePopup 
      v-if="show_message" 
      :message="message" 
      :show_message="show_message" 
      @close-message="closeMessage"
      :persistent="!clearable_message"
    ></MessagePopup>
    <FixCIFPopup 
      v-if="show_fix_cif_supplier && currentDocument" 
      :company="supplierdb_selected" 
      :cif_doc="currentDocument.metadata['vat_supplier']" 
      :show="show_fix_cif_supplier" 
      @close="show_fix_cif_supplier=false" 
      @fix="fix_cif_supplier"
    ></FixCIFPopup>
    <FixCIFPopup 
      v-if="show_fix_cif_customer && currentDocument" 
      :company="customerdb_selected" 
      :cif_doc="currentDocument.metadata['vat_customer']" 
      :show="show_fix_cif_customer" 
      @close="show_fix_cif_customer=false" 
      @fix="fix_cif_customer"
    ></FixCIFPopup>
    <v-dialog max-width="1200" v-if="currentDocument"
             v-model="show_invoice_lines_pop_up">
      {{ currentDocument.static_invoice }}
      <v-card style="background-color: white" >
        <InvoiceLinesEditorSimplified
          :invoice_lines="invoice_lines"
          readonly > </InvoiceLinesEditorSimplified>
      </v-card>
    </v-dialog>

    <v-dialog v-if="simulateDocDialog" v-model="simulateDocDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-autocomplete
            autocomplete="off"
            label="Empresa" 
            v-model="companySimulate"
            :items="get_companydbs"
            item-text="name"
            return-object
            hide-details
          ></v-autocomplete>
          <v-select 
            autocomplete="off" 
            label="Etiquetas" 
            v-model="tagsSimulate" 
            :items="doc_tags_values" 
            item-text="name" 
            item-value="value" 
            :multiple="true"
            clearable
          ></v-select>
          <v-select
            v-model="accounting_date_config"
            label="Fecha contable"
            item-value="id"
            item-text="text"
            :items="ACCOUNTING_DATE_OPTIONS"
          ></v-select>
          <v-text-field v-if="accounting_date_config=='configurated'"
            :class="{red:invalid_default_accounting_date}"
            label="Fecha (dd/mm/YYYY)" v-model="default_accounting_date">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="noSimulateItem()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="simulateItem()" :disabled="!companySimulate">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <app-modal-prompt
      v-model="changeCompanyDocDialog"
      :is-confirm-button-disabled="!companyChangeCompany"
      persistent
      @cancel="noChangeCompanyItem()"
      @confirm="changeCompanyItem()"
    >
      <template #title>
        Cambiar Empresa
      </template>
      <app-modal-row>
        <app-modal-col cols="12">
          <app-autocomplete
            autocomplete="off"
            label="Empresa"
            v-model="companyChangeCompany"
            item-text="name"
            return-object
            hide-details
            :items="get_companydbs"
            @change="getCompanyActivityList"
          ></app-autocomplete>
        </app-modal-col>
      </app-modal-row>
      <app-modal-row v-if="companyChangeCompany && showActivityField(companyChangeCompany, 'actividad') && !companyChangeCompany.hide_activities_master">
        <app-modal-col cols="12" class="mt-5">
          <app-select
            v-if="listActividadChangeCompany.length > 0"
            label="Actividad"
            v-model="actividadChangeCompany"
            :items="listActividadChangeCompany"
            item-value="code" 
            item-text="name"
            :clearable="true"
          />
          <app-text-field
            v-else
            kind="number"
            label="Actividad"
            v-model="actividadChangeCompany"
          ></app-text-field>
        </app-modal-col>
      </app-modal-row>
    </app-modal-prompt>

    <v-dialog v-if="addTagsDocDialog" v-model="addTagsDocDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-select 
            autocomplete="off" 
            label="Etiquetas" 
            v-model="tagsAddTags" 
            :items="doc_tags_values" 
            item-text="name" 
            item-value="value" 
            :multiple="true"
            clearable
          ></v-select>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="noAddTagsItem()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="addTagsItem()" :disabled="tagsAddTags.length==0">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="createTrainingDocDialog" v-model="createTrainingDocDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-select 
            autocomplete="off" 
            label="Etiquetas" 
            v-model="tagsTraining" 
            :items="doc_tags_values" 
            item-text="name" 
            item-value="value" 
            :multiple="true"
            clearable
          ></v-select>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="noTrainingItem()">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="trainingItem()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="currentDocument && historyPopup" v-model="historyPopup" max-width="1000"> 
      <v-card>
        <DocumentHistoryComponent :doc_id="currentDocument.id"></DocumentHistoryComponent>
      </v-card> 
    </v-dialog>

    <v-dialog v-if="errorDialog" v-model="errorDialog" max-width="1500">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <div v-if="invoice_error">
            Factura: <br/>
            {{ invoice_error }}
            <v-divider/>
          </div>
          <div v-if="account_moves_errors.length">
            <div v-for="ame in account_moves_errors" :key="ame.id">
              Asiento {{ame.id}}: <br/>
              {{ame.error}}
              <v-divider/>
            </div>
          </div>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" text class="primary-bckground" @click="errorDialog=false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="go_simulation_dialog" v-model="go_simulation_dialog" max-width="1000">
      <v-card>
        <v-card-title class="headline"></v-card-title>
        <v-card-text>
          <v-autocomplete
            autocomplete="off" 
            label="Simulaciones" 
            v-model="simulation_to_go" 
            :items="simulations" 
            item-text="text" 
            return-object
          ></v-autocomplete>
        </v-card-text>  
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined text class="primary-border" @click="go_simulation_dialog=false">Cancelar</v-btn>
          <v-btn color="white" text class="primary-bckground" @click="goToSimulation(simulation_to_go['cdb'], simulation_to_go['id'])">Ir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog envio factura por email-->
    <v-dialog v-model="show_send_dialog" max-width="800">
      <v-card>
          <v-card-title class="headline">
              <span class="text-h5 primary__blue py-1 ml-2">Enviar por email</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
              <SendByEmailForm 
              :email_to.sync="emailForm.to"
              :subject.sync="emailForm.subject"
              :body.sync="emailForm.body"
              ></SendByEmailForm>
          </v-card-text>
          <v-card-actions class="mr-4">
              <v-spacer></v-spacer>
              <v-btn outlined @click="cancelSend()" class="action__btn">Cancelar</v-btn>
              <v-btn color="primary_blue" class="white--text action__btn" @click="sendInvoice()" :disabled="cantSend">
                  Enviar
              </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar :absolute="!splitPaneMode" min-width="100%" :class="['toolbar-right-drawer', { 'toolbar-sticky': splitPaneMode }]" height="80px">

      <template v-if="currentDocument">
        <v-btn icon v-if="existsMoreThanOneDocument" :loading="loading_previous" class="btn-arrow" color="primary" :disabled="!canGoToPreviousDocument" @click="previous_document2()"><v-icon v-once>mdi-chevron-left</v-icon></v-btn>
        <v-btn icon v-if="existsMoreThanOneDocument" :loading="loading_next" class="btn-arrow" color="primary" :disabled="!canGoToNextDocument" @click="next_document2()"><v-icon v-once>mdi-chevron-right</v-icon></v-btn>
      </template>      

      <v-spacer/>

      <template>
        <!-- Botón para modo split pane: Restablecer paneles -->
        <v-tooltip top v-if="splitPaneMode">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="action-btn-doc"
              v-bind="attrs"
              v-on="on"
              @click="$emit('reset-split-pane')"
            >
              <v-icon size="28">mdi-arrow-collapse-horizontal</v-icon>
            </v-btn>
          </template>
          <span>Restablecer paneles</span>
        </v-tooltip>

        <!-- Botón original para modo drawer: Ampliar vista -->
        <v-tooltip top v-if="!splitPaneMode && showDrawerBtn">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="action-btn-doc"
              v-bind="attrs"
              v-on="on"
              @click="drawerLogic.expandDrawer"
            >
              <v-icon size="28">mdi-arrow-expand-horizontal</v-icon>
            </v-btn>
          </template>
          <span>Ampliar vista del documento</span>
        </v-tooltip>

        <v-tooltip top v-if="!splitPaneMode && drawer.expanded">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              class="action-btn-doc"
              v-bind="attrs"
              v-on="on"
              @click="drawerLogic.resetDrawer"
            >
              <v-icon size="28">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Volver a la vista original</span>
        </v-tooltip>
      </template>
      <FontScalerComponent :initialFactor="1" :targetClasses="['white', 'compact-table']" />

      <v-spacer/>

      <template v-if="currentDocument">
        <v-progress-circular 
          v-if="isWaitingFlow && permission.can_write"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <div v-else-if="permission.can_write">
          <v-btn 
            v-if="showRetry && currentDocument.state!='pending_approval'"
            color="primary" 
            :loading="flowLoading" 
            @click="reintentar()" 
            :disabled="isWaitingFlow"
            rounded
            class="mr-2"
          >Reintentar</v-btn>
          <v-btn 
            v-else-if="currentDocument.state=='company_detected'"
            color="primary" 
            :loading="flowLoading" 
            @click="transfer_to_detected_company()" 
            :disabled="isWaitingFlow"
            rounded
            class="mr-2"
          >Transferir</v-btn>
          <v-btn 
            v-if="showRetry && currentDocument.state=='pending_approval'"
            color="primary" 
            :loading="flowLoading" 
            @click="reintentar()" 
            :disabled="isWaitingFlow"
            rounded
            class="mr-2"
          >APROBAR</v-btn>
          <v-btn 
            v-if="showContabilize"
            color="primary" 
            :loading="flowLoading" 
            @click="contabilizar()" 
            :disabled="isWaitingFlow"
            rounded
            class="mr-2"
          >Contabilizar</v-btn>
          <v-btn 
            v-if="currentDocument.state=='done_manually' && got_feature('feature_done_manually_set_accounting_date')"
            color="primary" 
            :loading="screen_data.ui_accDate_loading"
            @click="saveAccountingDate()" 
            :disabled="!accountingDateModified"
            rounded
            class="mr-2"
          >Modificar fecha contable</v-btn>
        </div>
      </template>

      <div class="action-btn-group">
        <v-btn
          v-if="currentDocument && !currentDocument.forced_move && !currentDocument.line_analytic_plan_updated"
          class="action-btn-doc"
          color="primary"
          :loading="documentWriting"
          :disabled="true"
          @click="saveLabels()"
          icon
        >
          <!-- :disabled="!canSave()" -->
          <v-icon v-once>mdi-content-save-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="currentDocument && (currentDocument.forced_move || currentDocument.line_analytic_plan_updated)"
          color="primary"
          class="action-btn-doc"
          :disabled="!canSave()"
          :loading="documentWriting"
          @click="saveDocument()"
          icon
        >
          <v-icon v-once>mdi-content-save-outline</v-icon>    
        </v-btn>
        <!-- <v-btn
          color="primary"
          v-if="showRetry || showContabilize"
          @click="toggleRotationMode()"
          icon
        >
          <v-icon>mdi-rotate-3d-variant</v-icon>
        </v-btn> -->
        
        <!--
        <v-btn
          v-if="got_feature('feature_invoice_lines')"
          color="primary"
          class="action-btn-doc"
          @click="downloadFacturae()"
          icon
        >
          <v-icon>mdi-file-download</v-icon>
        </v-btn>-->
        
        <v-btn
          v-if="got_feature('feature_diezsoftware_nube')"
          color="primary"
          class="action-btn-doc"
          @click="forceSendDocument()"
          icon
        >
          <v-icon>mdi-file-send</v-icon>
        </v-btn>

        <template v-if="(userData.is_staff || userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))">
          <v-progress-circular 
            v-if="loading_needs_tt_fix"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-tooltip top v-else-if="currentDocument">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                  <v-checkbox
                    color="primary" 
                    v-model="document_needs_tt_fix"
                    @change="deepNeedsTtFixState"
                  >
                  </v-checkbox>
              </div> 
            </template>
            <span>Necesita revisión etiquetas</span>
          </v-tooltip>
        </template>
      </div>
            
      <div class="action-btn-group">

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn 
                v-if="(userData.is_staff || userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))"
                color="primary"
                class="action-btn-doc" 
                icon
                @click="goMirrorDocument()"
                :disabled="!currentDocument"
              >
                <AppIcon src="/invoices/mirror.svg" :size="29" />        
              </v-btn>
            </div>
          </template>
          <span>Ver documento espejo</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn 
                v-if="(userData.is_staff || userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))"        
                color="primary"
                class="action-btn-doc"  
                icon
                @click="goSimulatedMirrorDocument()"
                :disabled="!(currentDocument && document_has_simulated_mirror)"
              >
                <v-icon v-once>mdi-airplane</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Ver documento simulado</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="userData.user_role.value != 'customer' && userData.user_role.value != 'customer_consult'"
              color="primary"
              class="action-btn-doc"
              icon
              @click="show_send_dialog = true"
              v-on="on"
            >
              <v-icon v-once>mdi-send-variant-outline</v-icon>
            </v-btn>
          </template>
          <span>Enviar por email</span>
        </v-tooltip>

      </div>

      <v-menu
        v-if="true || showRetry || showContabilize || (currentDocument && currentDocument.state=='pending_sync' && getActions.some(el => el.id === 'mark_as_pending_review'))"
        v-model="menu"
        :close-on-click="false"
        :close-on-content-click="false"
        offsetY
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="action-btn-doc ml-1"
            color="primary"
            v-if="true || showRetry || showContabilize || (currentDocument && currentDocument.state=='pending_sync' && getActions.some(el => el.id === 'mark_as_pending_review'))"
            icon
            v-bind="attrs"
            v-on="on"
            :disabled="Boolean(permission.is_readonly)"
          >
            <v-icon v-once>mdi-menu</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group color="primary">
            <div v-for="(action, index) in getActions" :key="index">
              <v-list-item
                v-if="action.id=='force_docs_state_to_done'"
                v-show="currentDocument && currentDocument.state=='error_account_connector'"
                @click="go(action.id)"
                :class="{ list: true}"
              >
                <v-list-item-title class="list-title">{{ action.name }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else-if="action.id=='mark_as_pending_review'"
                v-show="currentDocument && currentDocument.state=='pending_sync'"
                @click="go(action.id)"
                :class="{ list: true}"
              >
                <v-list-item-title class="list-title">{{ action.name }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else-if="action.id=='done_manually'"
                v-show="currentDocument && currentDocument.state != 'done_migrated'"
                @click="go(action.id)"
                :class="{ list: true}"
              >
                <v-list-item-title class="list-title">{{ action.name }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else-if="action.id!='rotate_doc'"
                :disabled="currentDocument && currentDocument.state=='pending_sync'"
                @click="go(action.id)"
                :class="{ list: true}"
              >
              <!-- class="list" -->
                <v-list-item-title class="list-title">{{ action.name }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list-item-group>
        </v-list>
      </v-menu>
      

    </v-toolbar>

    <div class="white">
    <v-row class="px-4" v-if="userData.can_debug_documents">
      <v-col cols="3" class="pr-0">
        <v-btn color="primary" @click="changeDrawerMode()"><v-icon v-once>mdi-autorenew</v-icon></v-btn>
      </v-col>
      <v-col cols="6" class="pr-0">
        <v-list-item-title class="title">Modo Cliente</v-list-item-title>
      </v-col>
    </v-row>

    <v-row v-if="showErrorBtn && (invoice_error || account_moves_errors.length) && (userData.is_staff || userData.hasOwnProperty('username') && session_information.hasOwnProperty('username') && (session_information.username != userData.username))">
      <v-col cols="3" class="ml-4">
        <v-btn color="red" @click="errorDialog = true"><v-icon v-once>mdi-alert-decagram</v-icon></v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters class="pt-4 px-4 pb-2">
      <v-col cols="12" sm="6" class="pr-0" v-if="currentDocument">         
        <v-autocomplete
            class="select-invoice-stylev2"
            :class="{
              'disable-text': isDisabled,
              'activate-text': !isDisabled
            }"          
            autocomplete="off"
            v-model="document_kind"
            :items="availableDocs"
            item-text="text"
            item-value="id"
            :disabled="isDisabled"
            outlined              
            dense
            
        >
          <template v-slot:prepend>
            <label>Tipo de Documento</label>
          </template>
        </v-autocomplete>
      </v-col>
      <v-progress-circular 
          v-if="loading_punteado"
          indeterminate
          color="primary"
        ></v-progress-circular>
      <v-col cols="2" sm="1" class="pl-2" v-else-if="currentDocument && userData['available_features']['feature_can_mark_doc_as_punteado']">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-checkbox class="checkbox-invoice-rounded rounded-lg"
                          v-model="document_punteado"
                          @change="deepPunteadoState()"
                          off-icon="mdi-checkbox-blank-circle-outline"
                          on-icon="mdi-checkbox-marked-circle"
                          >
              </v-checkbox>
            </div> 
          </template>
          <span>Punteado</span>
        </v-tooltip>
      </v-col>

      <v-col cols="12" sm="5">
        <v-select 
          class="select-invoice-stylev2"
          :class="[
            'border-' + getStateColorIcon, 
            { 
              'disable-text': isDisabled, 
              'activate-text': !isDisabled 
            }
          ]"
          :readonly="true" 
          :items="docState" 
          v-if="currentDocument" 
          v-model="currentDocument.state"          
          outlined
          dense
        >
          <template v-slot:prepend>
            <label>&nbsp;&nbsp;&nbsp;Estado</label>
          </template>
          <template v-slot:append>          
            <div v-if="currentDocument && document_state === 'error_document_duplicated'">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn
                    max-width="25"
                    min-width="20" 
                    icon 
                    class="btn-invoice-detail btn-inside-input-right" 
                    v-bind="attrs"
                    v-on="on"
                    @click="setSearchAndRedirectToList"
                  >                
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Buscar duplicados</span>
              </v-tooltip>
            </div>
            <v-icon v-else class="select-icon-state" :color="getStateColorIcon">mdi-checkbox-blank-circle</v-icon>
          </template>
        </v-select>
      </v-col>

      <v-col cols="10" sm="5" class="pr-2" v-if="showActivityField(currentDocument && currentDocument.companydb_info, 'actividad') && got_feature('feature_actividad_selector') && activitySwitcher.length > 0 && currentCompany && !currentCompany.hide_activities_master">
        <v-autocomplete
          class="select-invoice-stylev2"
          :background-color="activityError"
          v-model="document_actividad"
          :items="activitySwitcher"
          item-value="code" item-text="name"
          :clearable="true"
          :disabled="!currentDocument || isWaitingFlow"
          outlined              
          dense
          append-icon="mdi-chevron-down"
        >
          <template v-slot:prepend>
            <label>Actividad</label>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="10" sm="5" class="pr-2" v-else-if="showActivityField(currentDocument && currentDocument.companydb_info, 'actividad') && currentCompany && !currentCompany.hide_activities_master">
        <doc-text-field
          :background-color="activityError"
          :disabled="!currentDocument || isWaitingFlow"
          v-model="document_actividad"
          :hide-details="true"
          label="Actividad"
          stylev2
          >
        </doc-text-field>
      </v-col>
      <v-col cols="10" sm="5" class="pr-2" v-else-if="showActivityField(currentDocument && currentDocument.companydb_info, 'actividad_str') && got_feature('feature_actividad_str_field') && got_feature('feature_actividad_selector') && activitySwitcher.length > 0 && currentCompany && !currentCompany.hide_activities_master">
        <v-autocomplete
          class="select-invoice-stylev2"
          v-model="document_actividad_str"
          :items="activitySwitcher"
          item-value="code" item-text="name"
          :clearable="true"
          :disabled="!currentDocument || isWaitingFlow"
          :background-color="activityError"
          outlined
          dense
        >  
          <template v-slot:prepend>
            <label>Actividad</label>
          </template>
        </v-autocomplete>
        
      </v-col>
      <v-col cols="10" sm="5" class="pr-2" v-else-if="showActivityField(currentDocument && currentDocument.companydb_info, 'actividad_str') && got_feature('feature_actividad_str_field') && currentCompany && !currentCompany.hide_activities_master">
        <doc-text-field
          :background-color="activityError"
          :disabled="!currentDocument || isWaitingFlow"
          v-model="document_actividad_str"
          label="Actividad"
          stylev2
          >
        </doc-text-field>
      </v-col>
      <v-col cols="10" sm="5" class="pr-2" v-if="userData['available_features']['feature_document_projects'] && (hasMasterPermission('project') && currentCompany && !currentCompany.hide_projects_master)">
        <v-autocomplete
          class="select-invoice-stylev2" 
          :clearable="true" 
          :items="currentDocument.companydb_info.projects"
          v-model="document_project" 
          item-text="name" 
          item-value="id"
          :background-color="showRequiredProjectError?'#ff9898':'#ffffff'"
          outlined
          dense
        >  
          <template v-slot:prepend>
            <label>Proyecto</label>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="10" sm="5" v-if="got_feature('feature_channel') && (hasMasterPermission('channel') && currentCompany && !currentCompany.hide_channels_master)">
        <v-autocomplete 
          class="select-invoice-stylev2 pr-2"
          :clearable="true" 
          :items="currentDocument.companydb_info.channels" 
          v-model="document_channel" 
          item-text="name" 
          item-value="channel_id"
          outlined
          dense
        >
          <template v-slot:prepend>
            <label>Canal</label>
          </template>
          
        </v-autocomplete>
        <!-- :background-color="showRequiredProjectError?'#ff9898':'#ffffff'" -->
      </v-col>
      <v-col cols="10" sm="5" v-if="got_feature('feature_sections') && (hasMasterPermission('section') && currentCompany && !currentCompany.hide_sections_master)">
        <v-autocomplete 
          class="select-invoice-stylev2 pr-2"
          :clearable="true" 
          :items="currentDocument.companydb_info.sections" 
          v-model="document_section" 
          item-text="name" 
          item-value="section_id"
          outlined
          dense
        >
          <template v-slot:prepend>
            <label>Sección</label>
          </template>
          
        </v-autocomplete>
        <!-- :background-color="showRequiredProjectError?'#ff9898':'#ffffff'" -->
      </v-col>
      <v-col cols="10" sm="5" v-if="got_feature('feature_delegations') && (hasMasterPermission('delegation') && currentCompany && !currentCompany.hide_delegations_master)"> 
        <v-autocomplete 
          class="select-invoice-stylev2 pr-2"
          :clearable="true" 
          :items="currentDocument.companydb_info.delegations" 
          v-model="document_delegation" 
          item-text="name" 
          item-value="delegation_id"
          outlined
          dense
        >
          <template v-slot:prepend>
            <label>Delegación</label>
          </template>
          
        </v-autocomplete>
        <!-- :background-color="showRequiredProjectError?'#ff9898':'#ffffff'" -->
      </v-col>

      <v-col cols="10" sm="5" v-if="got_feature('feature_departments') && (hasMasterPermission('department') && currentCompany && !currentCompany.hide_departments_master)">
        <v-autocomplete 
          class="select-invoice-stylev2 pr-2"
          :clearable="true" 
          :items="currentDocument.companydb_info.departments" 
          v-model="document_department" 
          item-text="name" 
          item-value="department_id"
          outlined
          dense
        >
          <template v-slot:prepend>
            <label>Departamento</label>
          </template>
          
        </v-autocomplete>
        <!-- :background-color="showRequiredProjectError?'#ff9898':'#ffffff'" -->
      </v-col>

      <v-col cols="10" sm="5" v-if="got_feature('feature_expense_income_type') && (currentDocument && currentDocument.companydb_info)">
        <v-autocomplete
            class="select-invoice-stylev2"
            :clearable="true"
            :items="document_kind === 'in_invoice' ? expens_type : income_type"
            v-model="document_expens_income_type"
            :item-text="item => item.code+' '+item.name"
            item-value="eit_id"
            outlined
            dense
        >
          <template v-slot:prepend>
            <label>{{getExpensIncomeTypeLabel}}</label>
          </template>
        </v-autocomplete>
      </v-col>



    </v-row>
    <v-row no-gutters class="px-4">      
      <v-col cols="1" class="align-self-center" v-if="show_alert_btn()">
        <v-btn
          max-width="20"
          min-width="20"
          class="ml-1 mb-2 btn-invoice-detail"
          :color="alertColor" 
          @click="showError()">
          <v-icon v-once>mdi-alert</v-icon>
        </v-btn>
      </v-col>                   
    </v-row>
    <v-row class="px-4">
      <v-col cols="12" class="py-1" v-if="currentDocument && currentDocument['metadata_old'] && fixMotxo">
        <doc-text-field           
          v-model="currentDocument['metadata_old']" 
          label="metadata_old"
          readonly
          stylev2
        ></doc-text-field>
      </v-col>
    </v-row>
    <v-row class="px-4">
      <v-col cols="12" class="py-1" :key="currentDocument.id.toString()+tags_changing.toString()" v-if="currentDocument && currentDocument['metadata_old'] && fixMotxo">
        <v-btn v-for="tag in currentDocument['tags']" :key="currentDocument.id.toString()+tag+tags_changing.toString()"
          x-small
          label="tags"
          readonly
          @click="delete_tag_doc(tag)"
          class="mr-2"
        >{{tag}}</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="multiple_matching_companies" >
       <v-col cols="12" sm="10">
         <div style="font-size:14px" class="pl-4">
           Hay varias empresas que encajan, elija la correcta:
         </div>
       </v-col>
    </v-row>
    <v-row v-if="buzonView" class="px-4">
      <v-col cols="12" sm="10" v-if="currentDocument">
        <SelectorEmpresa
          style="margin-left: 10px;"
          name="SelectorEmpresa"
          :value="currentDocument.detected_company_id"
          :items="companyOptions"
          :return_obj="false"
          :readonly="false"
          :item_val="'id'" 
          @gotInput="company_chosen_manually"
        ></SelectorEmpresa>
      </v-col>
      
    </v-row>
    <div class="divider-invoice d-flex" v-if="currentDocument">
      <AppIcon src="/invoices/grading.svg" :size="29" class="divider-img" />
      <div class="mr-auto">FACTURA</div>
      <v-btn 
        class="mr-2 align-self-center"
        icon
        max-width="20"
        max-height="20"
        @click="toggleSectionVisibility('section_factura')">
        <AppIcon src="/invoices/arrow_up_alt.svg" :size="29" class="icon-display-section" v-if="show_section_factura" />
        <AppIcon src="/invoices/arrow_down_alt.svg" :size="29" class="icon-display-section" v-else />
      </v-btn>
    </div>    

    <invoice-info-v2 :key="currentDocument.id" v-if="currentCompany && currentDocument && ['in_invoice','out_invoice'].includes(currentDocument.kind) && !buzonView" :show_section_factura="show_section_factura" :show_section_taxes="show_section_taxes"/>
    <!--<payroll-info v-if="currentDocument && ['payroll'].includes(currentDocument.kind)" @on_supplierdb_changed="on_supplierdb_changed" @on_customerdb_changed="on_customerdb_changed" />-->
    
    <div class="divider-invoice d-flex" v-if="currentDocument">
      <AppIcon src="/invoices/quick_reference_all.svg" :size="29" class="divider-img" />
      <div class="mr-auto">DETALLES FACTURA</div>
      <v-btn 
        class="mr-2 align-self-center"
        icon
        max-width="20"
        max-height="20"
        @click="toggleSectionVisibility('section_detalles_factura')">
        <AppIcon src="/invoices/arrow_up_alt.svg" :size="29" class="icon-display-section" v-if="show_section_detalles_factura" />
        <AppIcon src="/invoices/arrow_down_alt.svg" :size="29" class="icon-display-section" v-else />
      </v-btn>
    </div>
    <div class="pa-2"></div>
    <div v-show="show_section_detalles_factura">

      <v-row v-if="currentDocument && feature_see_albaran" class="pa-4" no-gutters>
          <v-col cols="6" >
              <metadata-field
                  field-key="delivery_note_number" 
                  kind="text"
                  stylev2 
                  field-text="NÚM. ALBARÁN" 
                  :key="currentDocument.id.toString()+isWaitingFlow.toString()+'delivery_note_number'"/>
          </v-col>          
      </v-row>

      <template v-if="!buzonView">
        <v-row class="px-4" v-if="currentDocument && userData.available_features['feature_document_number'] && !got_feature('feature_document_number_prefix') && !got_feature('feature_document_number_str')">
          <v-col cols="6" class="py-1">
            <doc-text-field 
                kind="number" 
                @change="setDirty()"
                v-model="currentDocument.doc_number" 
                label="Número de documento"
                stylev2 
            />
          </v-col>
        </v-row>         
                
      </template>
      <v-list v-if="false" dense nav>
        <template
          v-for="label in $store.state.labels.human"
        >
          <v-list-item
            v-bind:key="label.name"
            class="pa-0 my-0"
          >
            <v-list-item-content
              class="pb-0 pt-1"
              :class="{selectedrow:label.name===selectedLabel}"
              style="height:26px"
            >
              <v-row no-gutters>
                <v-col 
                  cols="1"
                  class="pb-0 pr-0"
                >
                  <v-icon
                    v-if="label.name===selectedLabel" color="primary"
                    class="selected-chevron"
                  >mdi-chevron-right</v-icon>
                </v-col>
                <v-col
                  v-if="currentDocument"
                  cols="9"
                  class="pt-0 pb-0 pl-0 pr-0"
                >
                  <doc-text-field
                    :field-class="{
                      invalid: ['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && 
                      currentDocument.errorJson.includes(label.name)
                    }"
                    kind="text"
                    :label="label.text"
                    @focus="selectLabel({ label: label.name })"
                    v-model="that['metadata_'+label.name]"
                    :disabled="!currentDocument || currentDocument.forced_move || isWaitingFlow"
                    stylev2
                  ></doc-text-field>
                </v-col>
                <v-col cols="2" class="pt-0 pb-0 pr-0 pl-2">
                  <v-btn
                    class="btn-invoice-detail"
                    v-bind:color="label.color"
                    @click="selectLabel({ label: label.name })"
                    width="20"
                    min-width="20"
                    :disabled="!currentDocument || currentDocument.forced_move || isWaitingFlow"
                  >
                    <v-icon>mdi-tag</v-icon>
                  </v-btn>
                </v-col>
                
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </template>
        <!-- TODO: remove-->
        <v-simple-table v-if="false">
          <template v-slot:default>
            <thead>
              <tr>
                <th width="130px" class="text-left">
                  Type
                </th>
                <th class="text-left">
                  Base
                </th>
                <th class="text-left">
                  Tax
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="label in $store.state.labels.taxes_labels"
                
              >
              <tr :key="'tax_'+label.name" v-if="currentDocument && currentDocument.metadata[label.name]"
              >
                <td>
                  <v-text-field  readonly v-model="label.text"
                  >
                  </v-text-field>
                </td>
                <td><v-text-field
                    :class="{
                      invalid: ['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && 
                      currentDocument.errorJson.includes(label.name)
                    }"
                    
                    @focus="selectLabel({ label: label.name })"
                    v-model="currentDocument.metadata['base_'+label.name]"
                    dense
                  ></v-text-field></td>
                <td><v-text-field
                    :class="{
                      invalid: ['error_validating_data','error_checking_taxes'].includes(currentDocument.state) && 
                      currentDocument.errorJson.includes(label.name)
                    }"
                    
                    @focus="selectLabel({ label: label.name })"
                    v-model="currentDocument.metadata[label.name]"
                    dense
                  ></v-text-field></td>
              </tr>
              </template>
              
            </tbody>
          </template>
        </v-simple-table>
      </v-list>            
    

      <v-row class="px-4" v-if="got_feature('feature_invoice_notes')">
        <v-col cols="12" class="py-1">
          <doc-text-field
              kind="text"
              v-model="document_notes"
              label="Notas de Factura"
              stylev2
          ></doc-text-field>
        </v-col>
      </v-row>   
      <v-row class="px-4 pb-4">
        <v-col cols="12" class="py-1" v-if="currentDocument && currentDocument['originalFileName']">
          <doc-text-field 
            kind="text"
            v-model="currentDocument['originalFileName']" 
            label="Nombre del Archivo"
            readonly
            stylev2
            rounded
            :class="{
              'disable-text': isDisabled,
              'activate-text': !isDisabled
            }"
          ></doc-text-field>
        </v-col>
        <v-col cols="12" class="py-1" v-if="currentDocument && !buzonView">
          <doc-text-field
            v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type && currentDocument.companydb_info.companydb_type.type == 'invoice'" 
            :disabled="currentDocument.state!='done'" 
            :readonly="true" 
            v-model="currentDocument.entry_number" 
            label="Apunte"
            stylev2
          >
          </doc-text-field>
        </v-col>
        <v-col cols="6" class="py-1" v-if="currentDocument">
          <doc-text-field 
            :readonly="true" 
            v-model="currentDocument.uploaded_from" 
            label="Método de subida"
            stylev2
          >
          </doc-text-field>
        </v-col>
        <v-col cols="1" class="py-1" v-if="currentDocument && currentDocument.uploaded_from == 'EMAIL'">
            <v-progress-circular 
              v-if="loading_ignore"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <v-tooltip top v-else-if="currentDocument">
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  <v-checkbox class="checkbox-invoice-rounded rounded-lg"
                              v-model="document_ignore_in_the_future" 
                              @change="markAsAttachmentToIgnore()"
                              off-icon="mdi-checkbox-blank-circle-outline"
                              on-icon="mdi-checkbox-marked-circle"
                              >
                  </v-checkbox>
                </div> 
              </template>
            <span>Marcar como adjunto a ignorar</span>
          </v-tooltip>
          <!-- </doc-text-field> -->
        </v-col>
        <v-col cols="(currentDocument && currentDocument.uploaded_from == 'EMAIL')?5:6" class="py-1" v-else>
        </v-col>
        <v-col cols="6" class="py-1" v-if="currentDocument && got_feature('feature_export_filename')">
          <doc-text-field
            :readonly="true" 
            v-model="currentDocument.export_filename" 
            label="Archivo exportación"
            stylev2
          >
          </doc-text-field>
        </v-col>
      </v-row>
      <template v-if="got_feature('feature_ai_detected_lines')">
        <v-row v-if="currentDocument && currentDocument.static_invoice">
          <v-col>
            <v-btn style="margin-left: 10px;" primary @click="invoiceLinesPopUp()"> Ver líneas
              </v-btn>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col>
            <v-btn style="margin-left: 10px;" primary @click="detectarLineas()"> Detectar líneas
              </v-btn>
          </v-col>
        </v-row>
      </template>
    </div> <!--/ Section detalles_factura-->
    </div>
  </div>
</template>

<script>
import { client } from "@/api/client";
import { mapActions, mapGetters, mapState } from "vuex";
import MetadataField from './MetadataField.vue'
import DocTextField from "./DocTextField.vue";

import FixCIFPopup from '../components/FixCIFPopup.vue';
import JobProgress from '../components/JobProgress.vue';
import MessagePopup from '../components/MessagePopup.vue';
import InvoiceLinesEditorSimplified from "../components/InvoiceLinesEditorSimplified.vue"
import CreateCustomer from '../views/CreateCustomer.vue';
import CreateSupplier from '../views/CreateSupplier.vue';
import InvoiceInfoV2 from './InvoiceInfoV2.vue';
import InvoiceDetectedInfo from './InvoiceDetectedInfo.vue';
import SelectorEmpresa from '../components/SelectorEmpresa.vue';
import DocumentHistoryComponent from '../components/DocumentHistoryComponent.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppAutocomplete from "@/components/layout/AppAutocomplete.vue";
import AppSelect from '@/components/layout/AppSelect.vue';
import SendByEmailForm from '../modules/notifications/infrastructure/SendByEmailForm.vue'

import { mapFields } from 'vuex-map-fields';

import { query_dispatcher, sync_command_dispatcher } from "@/api/client";
import { CreateXMLFromInvoice } from "@/modules/facturae/app/CreateXMLFromInvoice";
import { InvoicesToDoneManually } from "@/modules/invoices/app/InvoicesToDoneManually";
import { STANDARD_LABELS, STANDARD_LABELS_CLIENT } from "../store/constants";
import { ACCOUNTING_DATE_OPTIONS, REGISTRO_DATE_OPTIONS } from '../store/constants.js';
import { mapFieldsMetadata, vuexPrefix, vuexPrefix2 } from "../store/vuex_utils";
import { dateIsInPaths, isValidDate } from '../utils';

import {ApiInvoiceableRepository} from '../modules/facturae/infra/ApiInvoiceableRepository'

import { SelectDetectedCompany } from "@/modules/companies/application/SelectDetectedCompany";
import { TransferDocumentToOtherCompany } from "@/modules/companies/application/TransferDocumentToOtherCompany";
import { copyToClipboard } from "@/utils/common";
import { get_error_accounting_message } from "@/modules/document/domain/Document";
import { SetAccDateDoneManuallyCommand } from "@/modules/invoices/app/SetAccDateDoneManuallyCommand";
import FontScalerComponent from "./FontScalerComponent.vue";
import { getLinkErrors, hasAnyError } from "@/modules/company/domain/Company";

export default {
  name: "RightDrawerClientModeV2",
  components: {
    MetadataField,
    DocTextField,
    CreateSupplier,
    CreateCustomer,
    FixCIFPopup,
    InvoiceInfoV2,
    InvoiceDetectedInfo,
    JobProgress,
    MessagePopup,
    SelectorEmpresa,
    InvoiceLinesEditorSimplified,
    DocumentHistoryComponent,
    AppBtn,
    AppModalCol,
    AppModalContainer,
    AppModalPrompt,
    AppModalRow,
    AppAutocomplete,
    AppSelect,
    SendByEmailForm,
    FontScalerComponent
  },
  inject:['registerRefreshFunc'],
  props: {
    splitPaneMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wait: false,
      just_clicked: false,
      ACCOUNTING_DATE_OPTIONS,
      REGISTRO_DATE_OPTIONS,
      classification:'human',
      loading_previous: false,
      loading_next: false,
      loading_page: false,
      loading_punteado: false,
      loading_needs_tt_fix:false,
      dialog: false,
      deleting: false,
      downloading: false,
      show_fix_cif_supplier: false,
      show_fix_cif_customer: false,
      supplierdb_selected: undefined,
      customerdb_selected: undefined,
      rotationPageMode: 'all',
      rotateProgressState: 'none',
      message: '',
      show_message: false,
      clearable_message:false,
      is_recording: false,
      menu:false,
      show_invoice_lines_pop_up: false,
      invoice_lines : [],
      chosen_company_id: undefined,

      loading_ignore : false,

      changeCompanyDocDialog: false,
      simulateDocDialog: false,
      addTagsDocDialog: false,
      createTrainingDocDialog: false,
      historyPopup: false,

      companySimulate: null,
      tagsSimulate: [],
      accounting_date_config: 'invoice_date',
      default_accounting_date: null,
      invalid_default_accounting_date: false,
      default_accounting_date_error_message: undefined,

      companyChangeCompany: null,
      actividadChangeCompany: null,
      listActividadChangeCompany: [],
      tagsAddTags: [],
      tagsTraining: [],
      tags_changing:false,

      errorDialog: false,

      showErrorBtn: false,

      deleteProgressState: 'none',
      deleteJobId: 0,

      go_simulation_dialog: false,
      simulations: [],
      simulation_to_go: {},
      
      pending_states: [
        "text_detected",
        "uploading_bucket",
        "pending",
        "preprocessing",
        "preprocessed",
        "assigned_contract",
        "nif_detected",
        "nif_validated",
        "data_detected",
        "data_formatted",
        "data_validated",
        "move_created",
        "move_loaded",
        "check_duplicated_ok",
        "accounts_assigned",
        "split" ,
        "human_annotated",
        "oriented",
        "move_validated",
        "merging",
        "not_simulated",
        "in_rotation",
        "accounting_payment_move",
        "third_accounts_validated",
        "backtracking",
        "pending_approval",
        "waiting_signature",
        "company_detected",
        "detecting_company",
        "sync_payment_move"
      ],
      show_section_detalles_factura:true,
      show_section_factura:true,
      show_section_taxes:true,
      show_send_dialog:false,
      emailForm: {
        to: '',
        subject: '',
        body: ''
      },
      drawer: {
        expanded: false,
        originalWidth: null,
        originalMainStyles: null,
        btnActive: true,
        minWidth: 1500,
      },
      drawerLogic: {
        expandDrawer: () => {},
        resetDrawer: () => {},
        updateDrawerButtonVisibility: () => {},
        initDrawerStyles: () => {}
      },
      screen_data: {
        ui_accDate_loading: false
      },
    }
  },
  computed: {
    showDrawerBtn() {
      return !this.drawer.expanded && this.drawer.btnActive;
    },
    isDisabled() {
    return !this.currentDocument || 
           this.currentDocument.forced_move || 
           this.isWaitingFlow || 
           ['pending_connect', 'accounting_aplifisa_fiscal', 'accounting_invoice', 'pending_sync', 'done', 'done_manually', 'done_with_warning', 'pending_upload']
             .includes(this.currentDocument.state);
    },
    buzonView(){
      return this.currentCompany && this.currentCompany.companydb_type.value == 'inbox'
    },
    showRetry() {
      if (!this.currentDocument) return false

      // When using popup mode with error state, keep showing Reintentar even when forced_move is true
      if (this.got_feature('feature_show_popup_asientos') &&
          this.currentDocument.forced_move &&
          (this.currentDocument.state.startsWith("error_") || this.currentDocument.state === 'required_review')) {
        return true
      }

      return (
        (((this.currentDocument.state.startsWith("error_") && !['error_text_detection','error_format'].includes(this.currentDocument.state)) || ['required_review'].includes(this.currentDocument.state)) && !this.currentDocument.forced_move)
        ||
        (this.dirty && (['pending_review'].includes(this.currentDocument.state) || this.currentDocument.forced_move))
        ||
        (['pending_approval'].includes(this.currentDocument.state))
      )
    },
    showContabilize() {
      if (!this.currentDocument) return false

      // When using popup mode and document has error state, keep showing Reintentar instead
      if (this.got_feature('feature_show_popup_asientos') &&
          this.currentDocument.forced_move &&
          (this.currentDocument.state.startsWith("error_") || this.currentDocument.state === 'required_review')) {
        return false
      }

      return (
        !this.dirty
        &&
        (['pending_review'].includes(this.currentDocument.state) || this.currentDocument.forced_move)
        &&
        !['done','done_manually','done_with_warning','pending_sync','pending_connect','accounting_aplifisa_fiscal','accounting_invoice', 'pending_upload'].includes(this.currentDocument.state)
        &&
        !(this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['contabilize_on_csv'])
      )
    },
    existsMoreThanOneDocument() {
      return this.currentDocuments.length > 0
    },
    canGoToNextDocument() {
      return this.existsCurrentIndex && this.existsMoreThanOneDocument && !(this.currentIndex >= this.currentDocuments.length-1 && !this.currentPagination.next);
    },
    canGoToPreviousDocument() {
      return this.existsCurrentIndex && this.existsMoreThanOneDocument && !(this.currentIndex <= 0 && !this.currentPagination.previous);
    },
    alertColor(){
      if (this.currentDocument && ['required_review', 'done_with_warning'].indexOf(this.currentDocument.state) > -1){
        return "#FFE750" 
      }
      else{
        return "var(--v-error-base)" 
      }
    },
    docStateCols(){
      if(this.userData.is_staff || this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username)){
        return 7
      }
      else{
        return 10
      }
    },
    activityError(){
      let color = 'rgba(0,0,0,0)';
      const inErrorState = ['error_validating_data','error_checking_taxes'].includes(this.currentDocument.state);
      if (this.got_feature('feature_revision_required_actividad') && inErrorState && this.currentDocument.errorJson.includes('actividad')) {
        color = '#ff9898';
      }
      if (this.got_feature('feature_actividad_str_obligatoria') && inErrorState && this.currentDocument.errorJson.includes('actividad_str')) {
        color = '#ff9898';
      }
      return color;
    },
    cantSend() {
      const isEmpty = (value) => ['', null, undefined].includes(value);
      return isEmpty(this.emailForm.to) || isEmpty(this.emailForm.subject) || isEmpty(this.emailForm.body)
    },
    ...mapGetters({
      fixMotxo: "fixMotxo",
      availableTags: "availableTags",
      creatingMoves: "accounts/creatingMoves",
      flowLoading: "documents/flowLoading",
      documentWriting: "documents/documentWriting",
      currentDocument: "documents/currentDocument",
      selectedLabel: "documents/selectedLabel",
      selectedTextPayload: "documents/selectedTextPayload",
      currentDocuments: "documents/currentDocuments",
      currentIndex: "documents/currentIndex",
      currentPagination: "documents/currentPagination",
      docState: "documents/docState",
      tags: "get_tags",
      suppliers: "get_suppliers",
      customers: "get_customers",
      userData: 'me/userData',
      documentIsTrainerMode: 'documents/documentIsTrainerMode',
      dirty: 'documents/dirty',
      currentCompany: "getCurrentCompany",
      isWaitingFlow: "documents/isWaitingFlow",
      inRotationMode: "documents/inRotationMode",
      availableDocs: "me/availableDocs",
      rotateJobId:"documents/rotateJobId",
      get_companydbs: 'get_companydbs',
      permission: 'permissions/permission',
      existsCurrentIndex: 'documents/existsCurrentIndex',
      getIntActivities:'getIntActivities',
      got_feature: 'got_feature',
      get_delegations:'get_delegations',
      get_projects:'get_projects'
    }),
    ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS.map(x=>x.name),'')),
    ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS_CLIENT.map(x=>x.name),'')),
    ...mapFields('documents',vuexPrefix('document_',[
      'kind','state','supplierdb','customerdb','supplierdb_info','customerdb_info','actividad','has_mirror', 
      'has_simulated_mirror', 'punteado', 'project', 'channel', 'actividad_str','needs_tt_fix', 'notes',
      'expens_income_type', 'section','ignore_in_the_future', 'delegation', 'department'
    ],'document.')),
    // ...mapFields(['showModalSupplier','showModalCustomer']),
    ...mapFields('documents', ['documentIsDebuggerMode', 'documentAction']),
    ...mapFields('documents', vuexPrefix2('doc_', ['values'], 'documentListFiltersData2.', [  'tags', ])),
    ...mapFields(["projects", "channels", "activities", "sections", "expens_type", "income_type", "delegations", "departments"]),
    ...mapFields('me',vuexPrefix('',['feature_see_albaran'], 'userData.available_features.')),
    that(){
      return this
    },
    ...mapState([
      'session_information',
    ]),
    showRequiredProjectError(){
      return this.currentDocument.state == 'error_missing_fields' && this.currentDocument.errorJson['missing_fields'].includes('project') && !this.document_project
    },
    invoice_error() {
      try {
        return this.currentDocument.error;
      } catch {
        return '';
      }
    },
    multiple_matching_companies() {
      return this.currentDocument && this.currentDocument.state == 'error_multiple_matching_companies' && this.currentDocument.errorJson && 'matching_companies' in this.currentDocument.errorJson
    },
    companyOptions() {
      let items = this.get_companydbs;
      if (this.multiple_matching_companies) {
        items = items.filter (item => this.currentDocument.errorJson['matching_companies'].includes(item.id));
      }
      return items
    },
    account_moves_errors() {
      try {
        let errors = [];
        for (let i in this.currentDocument.accountMoves) {
          let am = this.currentDocument.accountMoves[i];
          if (am.error) {
            errors.push({ 'id': am.id, 'error': am.error })
          }
        }
        return errors;
      } catch {
        return [];
      }
    },
    getActions() {
      let actions = [];
      for (let i in this.documentAction) {
        if (['add_tags_doc'].includes(this.documentAction[i]['id'])) {
          if (this.userData && this.userData.is_staff) {
            actions.push(this.documentAction[i]);
          }
        } else if (['create_training_doc', 'check_document_history'].includes(this.documentAction[i]['id'])) {
          if (this.userData && (this.userData.is_staff || (this.session_information && this.session_information.username != this.userData.username))) {
            actions.push(this.documentAction[i]);
          }
        } else if (['simulate_doc'].includes(this.documentAction[i]['id'])) {
          if (this.userData && this.userData.can_see_training_documents) {
            actions.push(this.documentAction[i]);
          }
        } else if (['mark_as_pending_review'].includes(this.documentAction[i]['id'])) {
          if (this.userData && this.userData['available_features']['feature_can_mark_doc_as_pending_review']) {
            actions.push(this.documentAction[i]);
          }
        } else if (['force_docs_state_to_done'].includes(this.documentAction[i]['id'])) {
          if (this.userData && this.userData['available_features']['feature_can_force_docs_to_done']) {
            actions.push(this.documentAction[i]);
          }
        } else {
          actions.push(this.documentAction[i]);
        }
      }
      // actions.push({
      //   "id": "change_view",
      //   "name": "Vista Anterior"
      // })
      return actions;
    },
    activitySwitcher(){
      if (this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.activity_format === 'number'){
        return this.getIntActivities
      }
      else {
        return this.activities
      }
    },
    getFileurl(){
      let original = this.currentDocument.signed_original_url
      return original ? original : this.currentDocument.signed_url
    },
    getFileName(){
      let filename = 'doc_'+this.currentDocument.id.toString()
      //console.log(this.currentDocument)
      if (this.currentDocument.supplierName){
        filename += '_'+this.currentDocument.supplierName.replace(' ','_')
        }
      else if(this.currentDocument.customerName){
        filename += '_'+this.currentDocument.customerName.replace(' ','_')
      }
      if (this.currentDocument.originalFileName){
        filename += '_'+this.currentDocument.originalFileName
        }
        if(!this.currentDocument.excel_kind && !this.currentDocument.excel_line_index && !this.currentDocument.static_invoice){
        filename+='.pdf'
      }
      return filename
    },
    getStateColorIcon() {
      if (this.currentDocument.state.startsWith("error_")) {
        return "red";
      }
      else if (this.currentDocument.state.startsWith("done")) {
        return "green";
      }
      else {
        return "orange";
      }
    },
    getExpensIncomeTypeLabel(){
      return this.document_kind === 'in_invoice' ? 'Tipo de Gasto' : 'Tipo de Ingreso';
    },
    accountingDateModified() {
      return this.currentDocument.default_accounting_date != this.currentDocument.accounting_date
    },
  },  
  async mounted() {
    window.addEventListener('keydown', this.handleKeyDown);    

    this.drawerLogic = this.initDrawerResizeBehavior();
    this.drawerLogic.initDrawerStyles();
    this.drawerLogic.updateDrawerButtonVisibility();
    window.addEventListener("resize", this.drawerLogic.updateDrawerButtonVisibility);
    if (this.currentDocument && this.currentDocument.state == 'done_manually') {
      this.currentDocument.default_accounting_date = this.currentDocument.accounting_date
    }
    this.registerRefreshFunc(this.start_check_async_job_state)
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown);

    if (this.drawerLogic) {
      window.removeEventListener("resize", this.drawerLogic.updateDrawerButtonVisibility);
    }

    this.drawerLogic.resetDrawer();
  },
  watch: {},
  methods: {
    initDrawerResizeBehavior() {
      const rightDrawerElement = document.querySelector('.drawer.v-navigation-drawer--right');
      const mainContentWrapperElement = document.querySelector('.v-main__wrap');

      const applyInlineStyles = (element, styles = {}) => {
        for (const property in styles) {
          element.style[property] = styles[property] || '';
        }
      };

      const expandRightDrawer = () => {
        if (this.drawer.expanded || !rightDrawerElement || !mainContentWrapperElement) return;

        applyInlineStyles(mainContentWrapperElement, {
          flex: 'unset',
          width: '47.9vw',
        });

        rightDrawerElement.style.width = window.innerWidth <= 1600 ? '46.4vw' : '47.4vw';
        this.drawer.expanded = true;
      };

      const resetRightDrawer = () => {
        if (!rightDrawerElement || !mainContentWrapperElement) return;

        rightDrawerElement.style.width = this.drawer.originalWidth || '360px';

        const originalStyles = this.drawer.originalMainStyles || {};
        applyInlineStyles(mainContentWrapperElement, {
          width: originalStyles.width,
          flex: originalStyles.flex,
          marginRight: originalStyles.marginRight,
        });

        this.drawer.expanded = false;
      };

      const updateDrawerToggleButtonVisibility = () => {
        const isWideEnough = window.innerWidth > this.drawer.minWidth;
        this.drawer.btnActive = isWideEnough;

        if (!isWideEnough && this.drawer.expanded) {
          resetRightDrawer();
        }
      };

      const captureInitialDrawerStyles = () => {
        if (!rightDrawerElement || !mainContentWrapperElement) return;

        const drawerStyles = getComputedStyle(rightDrawerElement);
        const mainWrapStyles = getComputedStyle(mainContentWrapperElement);

        this.drawer.originalWidth = drawerStyles.width;
        this.drawer.originalMainStyles = {
          width: mainWrapStyles.width,
          flex: mainWrapStyles.flex,
          marginRight: mainWrapStyles.marginRight,
        };

        updateDrawerToggleButtonVisibility();
      };

      return {
        expandDrawer: expandRightDrawer,
        resetDrawer: resetRightDrawer,
        updateDrawerButtonVisibility: updateDrawerToggleButtonVisibility,
        initDrawerStyles: captureInitialDrawerStyles,
      };
    },
    async company_chosen_manually(input){
      await new SelectDetectedCompany(sync_command_dispatcher).run(input,this.currentDocument.id)
      this.fetchDocumentMetadata({ id: this.currentDocument.id })
    },
    async transfer_to_detected_company(){
      await new TransferDocumentToOtherCompany(sync_command_dispatcher).run(this.currentDocument.id)
      this.$router.push({ path: '/'+this.currentCompany.id.toString()+'/documents' })
    },    
    toggleSectionVisibility(section) {      
      switch (section) {
        case "section_detalles_factura":
          this.show_section_detalles_factura = !this.show_section_detalles_factura;
          break;
        case "section_factura":
          this.show_section_factura = !this.show_section_factura;
          break;
        case "section_taxes":
          this.show_section_taxes = !this.show_section_taxes;
          break;
      }
    },
    handleKeyDown(e) {
      // ctrl + keyCode shortcuts
      if (!e.ctrlKey) return
      switch(e.keyCode) {
        case 13: // ctrl + enter
          this.onCtrlEnter()
          break
        case 37: // ctrl + ArrowLeft
          this.handlePrevious()
          break
        case 39: // ctrl + ArrowRight
          this.handleNext()
          break;
        case 121: // ctrl + F10
          this.showErrorBtn = !this.showErrorBtn;
          break;
        default:
          break
      }
    },
    onCtrlEnter() {
      if (!this.isWaitingFlow && (this.showRetry || this.showContabilize)) {
        this.continueFlow2()
      }
    },
    handleNext() {
      if (!this.isAnyInputFocused() && this.canGoToNextDocument) {
        this.next_document()
      }
    },
    handlePrevious() {
      if (!this.isAnyInputFocused() && this.canGoToPreviousDocument) {
        this.previous_document()
      }
    },
    isAnyInputFocused() {
      const inputTypes = ['input', 'select', 'button', 'textarea']
      return inputTypes.includes(document.activeElement.tagName.toLowerCase())
    },
    enter() {
      this.saveLabels({ and_go_back_to: "/documents" });
    },
    toggleRotationMode() {
      this.setRotation(!this.inRotationMode)
    },
    start_check_async_job_state(id){
      this.check_async_job_state(id)
    },
    fix_cif_supplier(cif){
      this.fixCompanyCIF({company_id:this.supplierdb_selected.id,cif:cif,url:'supplierdbs/'}).then(()=>{
        this.setSuppliers(this.currentCompany['id'])
        this.show_fix_cif_supplier=false;
      })
    },
    fix_cif_customer(cif){
      this.fixCompanyCIF({company_id:this.customerdb_selected.id,cif:cif,url:'customerdbs/'}).then(()=>{
        this.setCustomers(this.currentCompany['id'])
        this.show_fix_cif_customer=false;
      })
    },

    check_async_job_state(id){
      if(id==this.$store.state.documents.document.id.toString()){
          this.fetchDocumentMetadata({ id: this.$store.state.documents.document.id }).then(() => {
          if(['pending','running'].includes(this.$store.state.documents.document.async_job_state)){
            setTimeout(()=>this.check_async_job_state(this.$store.state.documents.document.id),3000)
          }
          else{
            this.resetThirdsIfNeeded()
          }
        })
      }
      
    },
    continueFlow2(){
      this.continueFlow().then(()=>{
        if(['pending','running'].includes(this.currentDocument.async_job_state)){
          setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id),3000)
        } else if (this.currentDocument.async_job_state === "done" && this.is_recording) {
          if (this.canGoToNextDocument && ['done', 'pending_connect', 'accounting_aplifisa_fiscal','accounting_invoice'].includes(this.$store.state.documents.document.state)) {
            this.next_document();
          }
          this.is_recording = false;
        }
        else{
          this.resetThirdsIfNeeded()
        }
      })
    },
    resetThirdsIfNeeded(){
      if(this.currentDocument.kind=='in_invoice' && this.currentDocument.supplierdb_info){
        let id = this.currentDocument.supplierdb_info.id
        let list_of_ids = this.suppliers.map(x=>x.id)
        if(!list_of_ids.includes(id)){
          this.setSuppliers(this.currentCompany['id'])
        }
      }
      else if(this.currentDocument.kind=='out_invoice' && this.currentDocument.customerdb_info){
        let id = this.currentDocument.customerdb_info.id
        let list_of_ids = this.customers.map(x=>x.id)
        if(!list_of_ids.includes(id)){
          this.setCustomers(this.currentCompany['id'])
        }
      }
    },
    saveDocument() {
      this.saveDocWithoutContinueFlow();
    },
    reintentar() {
      this.continueFlow2();
    },
    contabilizar() {
      if (this.hasLinkErrors()) {
        this.showMessage("Esta empresa tiene ejercicios con fechas erróneas. Revise los ejercicios antes de contabilizar.")
        return
      }
      this.is_recording = true;
      this.continueFlow2();
    },
    async saveAccountingDate() {
      // console.log("saveAccountingDate", this.currentDocument.default_accounting_date)
      let cmd = new SetAccDateDoneManuallyCommand(this.screen_data)
      let cmd_output = await cmd.run([this.currentDocument.id], this.currentDocument.default_accounting_date)
      if (cmd_output == null) {
        this.showMessage("Algo ha ido mal.")
        this.fetchDocument({ id: this.currentDocument.id })
      }
      else if (cmd_output == "wrong_date") {
        this.showMessage("Fecha de contabilización incorrecta")
        this.fetchDocument({ id: this.currentDocument.id })
      }
      else { console.log("Fecha de contabilización modificada") }
    },
    async cambiarVista() {
      const idUser = this.userData["user"]
      const view = "old_view"
      let command_dispatcher = sync_command_dispatcher
      await command_dispatcher.dispatch('set.detail.invoice.view',
        {
          "user_id": idUser,
          "view": view
        }
      )
      window.location.reload();
    },

    delete_tag_doc(t){
      this.tags_changing=true
      client.post("delete_tag_doc/" , {'doc_id':this.currentDocument.id,'tag':t})
        .then(() => {
            this.fetchDocumentMetadata({ id: this.$store.state.documents.document.id })
            .then(() => {
              this.tags_changing=false
            })
      })
    },
    async invoiceLinesPopUp(){
      let static_invoice_repo = new ApiInvoiceableRepository()
      let inv = await static_invoice_repo.find_by_id(this.currentDocument.static_invoice)
      console.log(inv)
      this.invoice_lines = inv.lines
      this.show_invoice_lines_pop_up = true
    },

    async detectarLineas(){
      let command_dispatcher = sync_command_dispatcher
      let res = await command_dispatcher.dispatch('detect.document.lines', { doc_id: this.currentDocument.id })
      console.log(res)
    },
    previous_document(){
      this.loading_previous=true
      if(this.currentIndex>=1){
        var params = { name: "document-detail", params: { document: this.currentDocuments[this.currentIndex-1].id.toString() } };
        this.selectLabel({ label: null });
        this.$router.push(params);
        this.fetchDocument({ id: this.currentDocuments[this.currentIndex-1].id }).then(() => {})
        this.setCurrentIndex(this.currentIndex-1)
        this.loading_previous=false
      }
      else{
        let url_split=this.currentPagination.previous.split('/api')
        let url = url_split[url_split.length-1]
        client.get(url).then(response => {
          this.setCurrentDocs(response.data);
          let ind = response.data.results.length-1;
          this.setCurrentIndex(ind);
          if (this.currentDocuments.length) {
            var params = { name: "document-detail", params: { document: this.currentDocuments[ind].id.toString() } };
            this.selectLabel({ label: null });
            this.$router.push(params);
           this.fetchDocument({ id: this.currentDocuments[ind].id }).then(() => {})
          } else {
            var params = { name: "document-list" };
            this.$router.push(params);
          }
          this.loading_previous=false
        });
      }
    },
    next_document(){
      this.loading_next=true
      if(this.currentIndex+1<=this.currentDocuments.length-1){
        var params = { name: "document-detail", params: { document: this.currentDocuments[this.currentIndex+1].id.toString() } };
        this.selectLabel({ label: null });
        this.$router.push(params);
        this.fetchDocument({ id: this.currentDocuments[this.currentIndex+1].id }).then(() => {})
        this.setCurrentIndex(this.currentIndex+1)
        this.loading_next=false
      }
      else{
        let url_split=this.currentPagination.next.split('/api')
        let url = url_split[url_split.length-1]
        client.get(url).then(response => {
          this.setCurrentDocs(response.data);
          this.setCurrentIndex(0);
          if (this.currentDocuments.length) {
            var params = { name: "document-detail", params: { document: this.currentDocuments[0].id.toString() } };
            this.selectLabel({ label: null });
            this.$router.push(params);
            this.fetchDocument({ id: this.currentDocuments[0].id }).then(() => {})
          } else {
            var params = { name: "document-list" };
            this.$router.push(params);
          }
          this.loading_next=false
        });
      }
    },
    wait_to_func(func) {
        if (!this.wait && !this.loading_page) {
            this.just_clicked = false;
            func();
        }
        else{
            this.wait = false;
            setTimeout(() => {
                this.wait_to_func(func);
            }, 300);
        }
    },
    jump_document(jump){
      this.setCurrentIndex(this.currentIndex+jump)
      if(this.currentIndex>this.currentDocuments.length-1){ //si s'acaba la pag carreguem següent
          this.setCurrentIndex(this.currentIndex-this.currentDocuments.length)
          this.goToNextPage();
      }
      else if(this.currentIndex<0){ //si s'acaba la pag carreguem anterior
          this.goToPreviousPage(); //gestionem index post get 
      }
      this.wait = true;
      if (!this.just_clicked) {
          setTimeout(() => {
              this.wait_to_func(this.setDocumentToCurrentIndex);
          }, 300); 
          this.just_clicked = true;
      }
    },
    next_document2(){
      if (this.got_feature('feature_next_page_bunch_clicks')){
        this.jump_document(1); //acumula clicks per a no fer peticions de més i evitar condicions de carrera
      }
      else{
        this.next_document(); 
      }
        
    },
    previous_document2(){
      if (this.got_feature('feature_next_page_bunch_clicks')){
        this.jump_document(-1);
      }
      else{
        this.previous_document();
      }
    },

    setDocumentToCurrentIndex(){
      this.loading_next=true
      var params = { name: "document-detail", params: { document: this.currentDocuments[this.currentIndex].id.toString() } };
      this.selectLabel({ label: null });
      this.$router.push(params);
      this.fetchDocument({ id: this.currentDocuments[this.currentIndex].id }).then(() => {})
      this.loading_next=false
    },

    goToNextPage(){
      if (!this.currentPagination.next) {
        this.setCurrentIndex(this.currentDocuments.length-1)
        return;
      }
      let url_split=this.currentPagination.next.split('/api')
      let url = url_split[url_split.length-1]
      this.loading_page = true
      client.get(url).then(response => {
        this.setCurrentDocs(response.data);
        if (this.currentIndex > this.currentDocuments.length-1){
          this.setCurrentIndex(this.currentDocuments.length-1);
        }
        this.loading_page = false;
      });
    },

    goToPreviousPage(){
      if (!this.currentPagination.previous) {
        this.setCurrentIndex(0)
        return;
      }
      let url_split=this.currentPagination.previous.split('/api')
      let url = url_split[url_split.length-1]
      this.loading_page = true
      client.get(url).then(response => {
        this.setCurrentDocs(response.data);
        if (this.currentIndex < 0){
          this.setCurrentIndex(this.currentDocuments.length + this.currentIndex);
        }
        this.loading_page = false;
      });
    },

    changeDrawerMode() {
      // this.setIsTrainerMode(!this.documentIsTrainerMode);
      this.documentIsDebuggerMode = !this.documentIsDebuggerMode;
    },
    cancelSend() {
        this.show_send_dialog = false
        this.emailForm = {
            to: '',
            subject: '',
            body: ''
        }
    },
    async sendInvoice() {
      let args = {
        doc_id: this.currentDocument.id,
        company_id: this.currentCompany.id,
        to: this.emailForm.to,
        subject: this.emailForm.subject,
        body: this.emailForm.body
      }
      await sync_command_dispatcher.dispatch("send.invoice.mail", args)
      this.cancelSend()
    },
    hasMasterPermission(master) {
      return this.currentDocument && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.show && 
      this.currentDocument.companydb_info.companydb_type.params.show.includes(master);
    },

    ...mapActions({
      createMoveLines: "accounts/createMoveLines",
      continueFlow: "documents/continueFlow",
      deleteLabel: "documents/deleteLabel",
      selectLabel: "documents/selectLabel",
      saveLabels: "documents/saveLabels",
      setCurrentIndex: "documents/setCurrentIndex",
      fetchDocument: "documents/fetchDocument",
      fetchDocumentMetadata:"documents/fetchDocumentMetadata",
      setCurrentDocs: "documents/setCurrentDocs",
      setIsTrainerMode: "documents/setIsTrainerMode",
      generateFilters: "documents/generateFilters",
      setFiltersDataSearchValue: "documents/setFiltersDataSearchValue",
      setFiltersDataSearchDuplicateValue:"documents/setFiltersDataSearchDuplicateValue",
      setDocumentKind:"documents/setDocumentKind",
      setRotation:"documents/setRotation",
      setRotationMode:"documents/setRotationMode",
      cancelRotationMode:"documents/cancelRotationMode",
      saveRotation:"documents/saveRotation",
      setCustomers: "setCustomers",
      setSuppliers: "setSuppliers",
      fixCompanyCIF: "fixCompanyCIF",
      setDirty: "documents/setDirty",
      changeTrainerMode: "changeTrainerMode",
      getMirrorDocument: "documents/getMirrorDocument",
      getSimulatedMirrorDocument: "documents/getSimulatedMirrorDocument",
      getSimulationsFromTrainingDocument: "documents/getSimulationsFromTrainingDocument",
      setLoginas: "setLoginas",
      unsetLoginas: "unsetLoginas",
      splitDocument: "splitDocument",
      markDocsAsPendingReview: "documents/markDocsAsPendingReview",
      forceDocsStateToDone: "documents/forceDocsStateToDone",
      markAsPunteado: "documents/markAsPunteado",
      markAsDespunteado: "documents/markAsDespunteado",
      setNeedsTtFixState:"documents/setNeedsTtFixState",
      saveDocWithoutContinueFlow: "documents/saveDocWithoutContinueFlow",
      getCompanyActivities: "documents/getCompanyActivities",
      forceDocsSendInvoice: "documents/forceDocsSendInvoice",
      setMessageModal: 'messageModal/setModal',
      closeMessageModal: 'messageModal/closeModal'
    }),
    showMessage(m, icon) {
      const modal = {
        text: m,        
        actionConfirmButton: this.closeMessageModal,
      }
      if (icon) {
        modal.icon = icon
      }
      this.setMessageModal(modal)
    },
    async markAsAttachmentToIgnore() {
      this.loading_ignore = true
      let res = await sync_command_dispatcher.dispatch('set.ignore.in.the.future', { inv_id: this.currentDocument.id , value: this.currentDocument.ignore_in_the_future });
      if (!res.output.success){
        this.document_ignore_in_the_future = !this.document_ignore_in_the_future
        }
      this.loading_ignore = false
    },
    async deepPunteadoState(){
      this.loading_punteado = true
      if (this.currentDocument.punteado){
        await this.markAsPunteado({ send_filters:false, docs:[this.currentDocument.id] })
        this.loading_punteado = false
      }
      else{
        await this.markAsDespunteado({ send_filters:false, docs:[this.currentDocument.id] })
        this.loading_punteado = false
      }
    },
    async deepNeedsTtFixState(val){
      this.loading_needs_tt_fix = true
      await this.setNeedsTtFixState({value:val, docs:[this.currentDocument.id] })
      this.loading_needs_tt_fix = false
    },
    doRotation() {
      this.saveRotation().then(() => {
        this.rotateProgressState = "running"
      })
    },
    rotateDone() {
      window.location.reload()
    },
    showError() {
      let t, pm
      this.clearable_message = false
      if(this.currentDocument.kind=='in_invoice'){
        t='proveedor'
        pm='pago'
      }else{
        t='cliente'
        pm='cobro'
      }
      if (['required_review', 'done_with_warning'].indexOf(this.currentDocument.state) > -1){
        this.message = ''
        for(let i in Object.keys(this.currentDocument.warningJson)){
          let key =  Object.keys(this.currentDocument.warningJson)[i]
          this.message += this.currentDocument.warningJson[key] +"<br>"
        }
        this.clearable_message = true
      }
      else if (
        this.currentDocument.state == 'error_validating_moves'
        && this.currentDocument.errorJson
        && this.currentDocument.errorJson.user_error
        ) {

        const errorsHTML = `
          <p>Por favor, revise los siguientes errores:</p>
          <ul>
            ${this.currentDocument.errorJson.user_error.map(error => `<li>${error}</li>`).join('')}
          </ul>
        `
        this.message = errorsHTML
      }
      else if (this.currentDocument.state=='error_missing_fields'){
        let val_t_txt = {
          'project':'Proyecto',
          'description_sii':'Descripcion SII',
          'retention_type_name':'Tipo de retencion',
          'inv_number_to_rectify': 'Nº factura rectificada',
          'inv_date_to_rectify': 'Fecha factura rectificada',
          'vat_supplier': 'CIF Proveedor',
          'supplier': 'Nombre Proveedor',
          'vat_customer': 'CIF Cliente',
          'customer': 'Nombre Cliente',
          'rebu_precio_compra': 'Precio de compra REBU'
        }
        this.message = 'Faltan los campos obligatorios:<br>'
        for(let i in this.currentDocument.errorJson['missing_fields']){
          let fieldKey = this.currentDocument.errorJson['missing_fields'][i]
          let field
          if (fieldKey.startsWith('retention_account__')) {
            let retentionName = fieldKey.split('__')[1]
            field = 'Cuenta de retención ' + retentionName
          } else {
            field = val_t_txt[fieldKey]
          }
          this.message += "· "+field +"<br>"
        }
      } else if (this.currentDocument.state=='error_not_supported_operation'){
        this.message=this.currentDocument.error;
      } else if(this.currentDocument.state=='error_checking_taxes') {
        this.message=this.currentDocument.error;
      }
      let error_message = get_error_accounting_message(this.currentDocument.error, {t:t, pm:pm}, true)
      if (error_message != null) {
        this.message = error_message
      }
      this.show_message=true;
    },
    closeMessage(){
      this.show_message=false;
      if (this.currentDocument.state=='required_review'){
        client.patch('finish_required_review/',{'doc_id':this.currentDocument.id}).then(() => {
          this.message = ''  
          this.fetchDocument({ id: this.currentDocument.id})
        }).catch(err=>{
          console.error(err);
        });
      }
    },
    show_alert_btn(){
      if(this.currentDocument && (((this.currentDocument.state=='error_account_connector' && 
         (
          this.currentDocument.error.includes('Payment Innuva Error') ||
          this.currentDocument.error.includes('FiscalAccountDoesNotExist') ||
          this.currentDocument.error.includes('EjercicioCerrado') ||
          this.currentDocument.error.includes('AccountDoesNotExist') ||
          this.currentDocument.error.includes('Faltan las siguientes cuentas en el destino:') ||
          this.currentDocument.error.includes('Los siguientes campos no pueden estar vacíos:') ||
          this.currentDocument.error.includes('Error en la contabilización') ||
          this.currentDocument.error.includes('ContanetNSTPathDoesNotExist') ||
          this.currentDocument.error.includes('Suplidos account not configured') ||
          this.currentDocument.error.includes('Por alguna razón nos ha sido imposible acceder a la empresa,') ||
          this.currentDocument.error.includes('user_error') ||
          (
            this.currentDocument.error.includes('[Errno 13] Permission denied') &&
            this.currentDocument.error.includes('xslx.py') && 
            this.currentDocument.error.includes('zipfile.py')
          ) ||
          (this.currentDocument.error.includes('PermissionError: [Errno 13] Permission denied:') && this.currentDocument.error.includes('Inmatic.xlsx')) ||
          (this.currentDocument.error.includes('Se produjo un error en el cálculo del IVA/IGIC') && this.currentDocument.error.includes('Se ha grabado el apunte, pero debe comprobar el Tipo, la Base y el Total')) ||
          (
            this.currentDocument.error.includes('DatabaseError') && 
            this.currentDocument.error.includes('Problematic key') && 
            this.currentDocument.error.includes('CLAVEDAT') && 
            this.currentDocument.error.includes('EJERCICIO') && 
            this.currentDocument.error.includes('ACTIVIDAD')
          ) || this.currentDocument.error.includes('Contacta con ')
         ) ||  ( this.currentDocument.state=='error_format' && this.currentDocument.error.includes('Documento requiere contraseña')))
         ) || (['required_review', 'error_critical', 'error_missing_fields', 'done_with_warning'].indexOf(this.currentDocument.state) > -1)
         || (this.currentDocument.state=='error_validating_moves' && this.currentDocument.errorJson && this.currentDocument.errorJson.user_error))
      )
        return true
      if(this.currentDocument && this.currentDocument.state=='error_not_supported_operation' && this.currentDocument.error && this.currentDocument.error.length > 0)
        return true
      if(
        this.currentDocument && this.currentDocument.state=='error_checking_taxes' && this.currentDocument.error && this.currentDocument.error.length > 0 &&
        this.currentDocument.error.startsWith('No es posible contabilizar')
      )
        return true
      return false 
    },
    goMirrorDocument() {
      if ((this.userData.is_staff || (this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username)))) {
        let session_username = '';
        if (this.session_information.hasOwnProperty('username')) {
          session_username = this.session_information.username;
        }
        this.getMirrorDocument({ 'doc_id': this.currentDocument.id, 'session_username': session_username }).then(resp => {
          if (!resp.data.hasOwnProperty('ko')) {
            if (resp.data.hasOwnProperty('loginas')) {
              this.setLoginas(resp.data['loginas']).then(() => {
                this.$router.push({ 'name': 'document-detail', 'params': { 'companydb_id': resp.data['cdb_id'], 'document': resp.data['mirror_doc'] }}, () => {
                  this.$router.go();
                });
              });
            } else {
              let params = {
                'logged_username': this.session_information.username,
                'loginas_username': this.userData.username,
              };
              this.unsetLoginas(params).then(() => { 
                this.$router.push({ 'name': 'document-detail', 'params': { 'companydb_id': resp.data['cdb_id'], 'document': resp.data['mirror_doc'] }}, () => {
                  this.$router.go();
                });    
              });
            }
          }
        });
      }
    },
    changeDoc(cdb_id, doc_id) {
      let params = { 'companydb_id': cdb_id, 'document': doc_id }
      this.$router.push({ 'name': 'document-detail', 'params': params}, () => {
        this.$router.go();
      });
    },
    goSimulatedMirrorDocument() {
      if ((this.userData.is_staff || (this.userData.hasOwnProperty('username') && this.session_information.hasOwnProperty('username') && (this.session_information.username != this.userData.username)))) {
        let session_username = '';
        if (this.session_information.hasOwnProperty('username')) {
          session_username = this.session_information.username;
        }
        if (this.userData.can_see_training_documents) {
          this.getSimulationsFromTrainingDocument({ 'doc_id': this.currentDocument.id, 'session_username': session_username }).then(resp => {
            if (!resp.data.hasOwnProperty('ko')) {
              this.go_simulation_dialog = true;
              this.simulations = resp.data['simulated_mirror_docs'];
            }
          });
        } else {
          this.getSimulatedMirrorDocument({ 'doc_id': this.currentDocument.id, 'session_username': session_username }).then(resp => {
            if (!resp.data.hasOwnProperty('ko')) {
              this.changeDoc(resp.data['cdb_id'], resp.data['simulated_mirror_doc']);
            }
          });
        }
      }
    },
    goToSimulation(cdb_id, doc_id) {
      this.changeTrainerMode().then(() => {
        this.changeDoc(cdb_id, doc_id);
      })
    },
    async go(action) {
      console.log("action:", action)
      if (action == 'rotate_doc') {
        this.toggleRotationMode();
      } else if (action == 'split_doc') {
        this.splitDocument([ this.currentDocument, ]).then(() => {
          this.$router.replace({ name: 'document-list', params: { 'companydb_id': this.currentCompany.id } });
        }).catch(err => {
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err);
        });
      } else if (action == 'change_company_doc') {
        this.changeCompanyDocDialog = true;
      } else if (action == 'simulate_doc') {
        this.simulateDocDialog = true;
      } else if (action == 'add_tags_doc') {
        this.addTagsDocDialog = true;
      } else if (action == 'create_training_doc') {
        this.createTrainingDocDialog = true;
      } else if (action == 'check_document_history') {
        this.historyPopup = true;
      } else if (action == 'mark_as_pending_review') {
        this.markDocsAsPendingReview({ 'send_filters': false, 'docs': [ this.currentDocument.id, ]}).then(()=>{
          setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id),3000)
        }).catch(err=>{
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err)
        });
      } else if (action == 'force_docs_state_to_done') {
        this.forceDocsStateToDone({ 'send_filters': false, 'docs': [ this.currentDocument.id, ]}).then(()=>{
          setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id), 3000)
        }).catch(err=>{
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err)
        });
      } else if (action == 'force_send_invoice'){
        this.forceDocsSendInvoice({ 'send_filters': false, 'docs': [ this.currentDocument.id, ]}).then(()=>{
          setTimeout(()=>this.start_check_async_job_state(this.currentDocument.id), 3000)
        }).catch(err=>{
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err)
        });
      } else if (action == 'copy_id'){
        this.copyToClipboard(this.currentDocument.id);
      } else if (action == "change_view"){
        this.cambiarVista();
      } else if (action == "done_manually") {
        if (this.currentDocument.state == 'done_migrated') {
          this.message = "El estado 'Migrado Contabilizado' no se puede cambiar."
          this.show_message = true
          console.error(this.message)
        }
        else {
          await new InvoicesToDoneManually(sync_command_dispatcher).run([this.currentDocument.id]);
          this.next_document();
        }
      }
      this.menu = false;
    },



    async getCompanyActivityList() {
      let params = {
        'companydb_id': this.companyChangeCompany.id, 
        'feature_code': 'feature_actividad_selector', 
        'field_show': 'actividad'
      };
      this.listActividadChangeCompany =  await this.getCompanyActivities(params);
    },

    changeCompanyItem() {
      this.changeCompanyDocDialog = false;
      let doc_ids = [ this.currentDocument.id, ];
      let cdb_id = this.companyChangeCompany.id;
      let params = {'doc_ids': doc_ids, 'new_cdb_id': cdb_id, };
      if (this.companyChangeCompany && this.companyChangeCompany.companydb_type.params && this.companyChangeCompany.companydb_type.params.show && this.companyChangeCompany.companydb_type.params.show.includes('actividad') && !isNaN(this.actividadChangeCompany) && parseInt(Number(this.actividadChangeCompany)) == this.actividadChangeCompany && !isNaN(parseInt(this.actividadChangeCompany, 10))) {
        params['actividad'] = this.actividadChangeCompany;
      }
      client.post('change_company_doc/', params).then(response => {
        if ('ko' in response.data) {
          this.message=response.data['ko'];
          this.show_message=true;
        } else {
          this.$router.replace({ name: 'document-detail', params: { 'companydb_id': cdb_id, 'document': this.currentDocument.id } });
          this.$router.go();
        }
      }).catch(err=>{
        this.message='Algo ha ido mal';
        this.show_message=true;
        console.error(err);
      });
    },
    noChangeCompanyItem() {
      this.changeCompanyDocDialog = false;
      this.companyChangeCompany = null;
      this.actividadChangeCompany = null;
      this.listActividadChangeCompany = [];
    },
    addTagsItem() {
      this.addTagsDocDialog = false
      let doc_ids = [ this.currentDocument.id, ];
      let params = {'doc_ids': doc_ids, 'tags': this.tagsAddTags}
      client.post("add_tags_doc/" , params).then(response => {
        this.tagsAddTags = [];
      }).catch(err => {
        this.message='Algo ha ido mal';
        this.show_message=true;
        console.error(err);
      });
    },
    noAddTagsItem() {
      this.addTagsDocDialog = false;
      this.tagsAddTags = [];
    },
    trainingItem() {
      this.createTrainingDocDialog = false
      let doc_ids = [ this.currentDocument.id, ];
      let params = {'doc_ids': doc_ids, 'tags': this.tagsTraining }
      client.post("create_training_copies/" , params).then(response => {
        this.tagsTraining = [];
        this.document_has_mirror = true;
      }).catch(err => {
        this.message='Algo ha ido mal';
        this.show_message=true;
        console.error(err);
      });
    },
    noTrainingItem() {
      this.createTrainingDocDialog = false;
      this.tagsTraining = [];
    },



    simulateItem() {
      this.invalid_default_accounting_date = false;
      if(this.accounting_date_config=='configurated'){
        if(isValidDate(this.default_accounting_date)){
          let d_str_split = this.default_accounting_date.split('/')
          let d = new Date(d_str_split[1]+'/'+d_str_split[0]+'/'+d_str_split[2])
          this.default_accounting_date=this.date_to_string(d)
          this.document_has_simulated_mirror = true;
        }else{
          this.invalid_default_accounting_date = true;
        }
      }
      if (!this.invalid_default_accounting_date) {
        this.simulateDocDialog = false
        let doc_ids = [ this.currentDocument.id, ];
        let cdb_id = this.companySimulate.id;
        let params = {
          'doc_ids': doc_ids,
          'cdb_id': cdb_id,
          'tags': this.tagsSimulate,
          'accounting_date_config': this.accounting_date_config, 
          'default_accounting_date': this.default_accounting_date
        }
        client.post("create_simulation_copies/" , params).then(response => {
          if ('ko' in response.data) {
            this.message=response.data['ko'];
            this.show_message=true;
          } else {
            this.companySimulate = null;
            this.tagsSimulate = [];
            this.accounting_date_config = 'invoice_date';
            this.default_accounting_date = null;
          }
        }).catch(err => {
          this.message='Algo ha ido mal';
          this.show_message=true;
          console.error(err)
        });
      }
    },
    noSimulateItem() {
      this.simulateDocDialog = false;
      this.companySimulate = null;
      this.tagsSimulate = [];
      this.accounting_date_config = 'invoice_date';
      this.default_accounting_date = null;
    },
    date_to_string(d){
      var mm = d.getMonth() + 1;
      var dd = d.getDate();
      return [(dd>9 ? '' : '0') + dd, (mm>9 ? '' : '0') + mm, d.getFullYear()].join('/');
    },
    canSave() {
      const READONLY_STATES = [
        'pending_upload',
        'pending_connect',
        'accounting_aplifisa_fiscal',
        'accounting_invoice',
        'pending_sync',
        'done',
        'done_manually',
        'done_with_warning',
      ];
      return !(this.currentDocument && (this.isWaitingFlow || READONLY_STATES.includes(this.currentDocument.state)))
       || this.fixMotxo ;
    },
    setSearchAndRedirectToList() {
      this.setFiltersDataSearchDuplicateValue(this.metadata_inv_number)
      this.setDocumentKind(this.currentDocument.kind)
      this.$router.push({ name: 'document-list' })
      this.generateFilters()
    },
    showActivityField(companydb, field) {
      return companydb && companydb.companydb_type.params && companydb.companydb_type.params.show && companydb.companydb_type.params.show.includes(field)
    },

    forceSendDocument() {
      this.forceDocsSendInvoice({ 
        send_filters: false, 
        docs: [this.currentDocument.id],
      }).then(() => {
        this.loadingAction = true;
        this.showMessage('Sincronización iniciada correctamente');
        setTimeout(() => this.start_check_async_job_state(this.currentDocument.id), 3000);
      }).catch(err => {
        this.showMessage('Algo ha ido mal');
        this.loadingAction = false;
      });
    },

    async downloadFacturae(){
      
      let inv_id = this.currentDocument.id
      let filename =  this.getFileName.split('.')[0] + '.xml'
      await new CreateXMLFromInvoice(sync_command_dispatcher, this).run(inv_id,filename);





    //   let doc_ids = [ this.currentDocument.id, ];
    //   let params = {'doc_ids': doc_ids, 'tags': this.tagsTraining }
    //   // client.get("facturae/2236418" , params)
      
    //   client.get("facturae/"+this.currentDocument.id+"/download/" , params)
    //   .then(response => {
    //     let fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //     let fileLink = document.createElement("a");
    
    //     fileLink.href = fileURL;
    //     fileLink.setAttribute("download", "facturae.xml");
    //     document.body.appendChild(fileLink);
    
    //     fileLink.click();
        
    //   }).catch(err => {
    //     this.message='Algo ha ido mal';
    //     this.show_message=true;
    //     console.error(err);
    //   });
      
     },
     copyToClipboard,
     hasLinkErrors() {
      if (!this.currentCompany || !this.currentCompany.links) return false
      return hasAnyError(getLinkErrors(this.currentCompany.links))
    },

  },
};
</script>

<style scoped>

.toolbar-right-drawer {
  -webkit-box-shadow: 0px 1px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0px 1px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.12) !important;
  border-top-left-radius:10px;
}

.toolbar-sticky {
  position: sticky !important;
  top: 0;
  z-index: 10;
}
.toolbar-right-drawer >>> .v-btn {
  height: 32px !important;
  text-transform:capitalize;
}
.toolbar-right-drawer >>> .v-btn--contained {
  border-radius:10px;
}
.toolbar-right-drawer >>> .v-btn--icon {
  height: 32px !important;
  width: 32px !important;
}
.toolbar-right-drawer >>> .v-btn.v-btn--icon:first-child {
  margin-left:0px;
}
.toolbar-right-drawer >>> .v-btn--icon .v-icon {
  font-size:22px;
  height: 22px;
  width: 22px;
}
.toolbar-right-drawer >>> .v-btn--icon.btn-arrow {
  height: 30px !important;
  width: 30px !important;
  border:2px solid var(--v-primary-base);
  margin-right:4px;
  margin-left:4px;
}
.toolbar-right-drawer >>> .v-btn--icon.btn-arrow:not(.v-btn--disabled) {
  background-color:var(--v-primary-base);
}
.toolbar-right-drawer >>> .v-btn--icon.btn-arrow:not(.v-btn--disabled) .v-icon{
  color:white;
}
.toolbar-right-drawer .action-btn-group {
  background-color: #F6F6F6;
  border-radius: 10px;    
  height: 32px;
  margin-left: 4px;
  display:flex;
}
.toolbar-right-drawer .action-btn-doc {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 10px;
  background-color: #F6F6F6;
}
.toolbar-right-drawer .action-btn-doc:hover {
  background-color: #D1D1D1;
}
.toolbar-right-drawer .action-btn-doc .v-icon {
  color: #4e4e4e;
}
.toolbar-right-drawer .v-input--checkbox {
  padding-top:4px;
  margin-left:4px;
}
.toolbar-right-drawer .v-input--checkbox >>> .v-input--selection-controls__ripple {
  width:30px;
  height:30px;
  left:-10px;
  top:calc(50% - 22px);
  border-radius:10px;
}
.bg-white {
  background-color:white;
}
.selected-chevron {
  margin-right: 0.5em;
}
.primary-bckground {
  background-color: var(--v-primary-base);
}
.primary-border {
  border-color: var(--v-primary-base) !important;
}

/* Select invoice */
.select-invoice-stylev2 {
  font-size:12px;
  border-radius:2px;  
}
.select-invoice-stylev2 >>> fieldset {
  border-color:#B0B0B0;
}
.select-invoice-stylev2.border-red >>> fieldset{
  border-color:var(--v-error-base);
}
.select-invoice-stylev2.border-green >>> fieldset{
  border-color:#66F273;
}
.select-invoice-stylev2.border-orange >>> fieldset{
  border-color:#FF8533;
}

.select-invoice-stylev2 >>> .v-input__prepend-outer{
  margin-top:2px !important;
  text-wrap:nowrap;
  white-space: nowrap;
}
.select-invoice-stylev2 label {
  color:#454545;
  line-height: 20px;
  font-weight: 600;
  font-family: "Roboto";  
}
.select-invoice-stylev2 >>> .v-input__slot {
  min-height: 15px !important;
  padding-left:6px !important;
  padding-right:5px !important;
}
.select-invoice-stylev2 >>> input {
  padding: 0px !important;
  line-height:25px;
  font-weight: 400;
}
.select-invoice-stylev2 >>> .v-input__append-inner {
  margin-top:1px !important;
  padding-left:2px;
}
.select-invoice-stylev2 >>> .v-input__icon {
  width: 22px;
  height: 22px;
  max-width: 22px;
  min-width: 22px;
}
.select-invoice-stylev2 >>> .v-input__icon .v-icon {
  font-size:18px;
}

.select-invoice-stylev2 >>> .v-select__selection--comma {
  margin:0px;
}
.select-invoice-stylev2 >>> .v-select__selections {
    padding:0px !important;
    font-weight:300;
}
.select-invoice-stylev2 >>> .v-text-field__details {
  margin-bottom:4px;
  
}
.select-invoice-stylev2 >>> .v-text-field__details,
.select-invoice-stylev2 >>> .v-messages {
    min-height:0px;
    font-size:10px;
}

/* Select invoice rounded*/
.select-invoice-stylev2.v-input--is-readonly {
  border-radius: 20px !important;
}

.select-invoice-stylev2 .select-icon-state {
  padding-top: 4px;
  font-size: 15px;
}

/* Checkbox rounded */
.checkbox-invoice-rounded {
  margin-top:0px;
  padding-top: 2px;
  margin-left:0px;
}
.checkbox-invoice-rounded >>> .v-icon{
  width:20px;
  height:20px;
  font-size:20px;
}
.checkbox-invoice-rounded >>> .v-input--selection-controls__ripple {
  width:22px;
  height:22px;
  left:-9px;
  top: calc(50% - 20px);
}
.checkbox-invoice-rounded >>> .v-messages {
  min-height:0px;
}
.divider-invoice {
  color:var(--v-primaryDark-base);
  font-weight: bold;
  text-transform: uppercase;
  background-color: var(--v-primaryLighter-base);
  height: 40px;
  padding-left:12px;
  padding-top: 1px;
  line-height:39px;  
  font-size:13px;
}
.divider-invoice .icon-display-section {
  font-size:15px;
}
.divider-invoice .divider-img {
  width:24px;
  height:24px;
  align-self:center;
  margin-right:10px;
}

.btn-invoice-detail {
  height:20px !important;
  padding:0px !important;
}
.btn-invoice-detail >>> .v-icon {
  font-size:15px;  
}

.select-invoice-stylev2 .btn-inside-input-right {     
    background-color: red;
    margin-right: -5px;    
    border-radius: 0px 10px 10px 0px;
    color: white;
    height: 23px !important;
}

</style>

<style>

  .disable-text .v-select__selection {
    color: #6D6D6D !important;
  }

  .disable-text input {
    color: #6D6D6D !important;
  }

  .disable-text{
    color: #6D6D6D !important;
  }

  .disable-text.v-btn--disabled {
    color: #6D6D6D !important;
  }

  .disable-text img{
    opacity: 0.7 !important;
  }

  .activate-text .v-select__selection {
    font-weight: 400 !important;
  }

  .activate-text input{
    font-weight: 400 !important;
  }

  .activate-text{
    font-weight: 400 !important;
  }

  .activate-text.v-btn--disabled {
    font-weight: 400 !important;
  }

  .activate-text img{
    opacity: 1 !important;
  }
</style>